import React from "react";
import Meta from "../../global/Meta";

import EaglesNestJson from "./EaglesNestJson";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import "../Activities/Activities.scss";

const EaglesNestApartment = () => (
  <div>
    <Meta
      title="Lakeview Self contained serviced apartment in Queenstown Acommodation"
      desc="Discover remarkable mountain and lakeview from the self contained apartment in queenstown accommodation from dusk till dawn. This is self catering holiday home for your vacation."
      keywords="serviced apartment in queenstown, self contained queenstown apartment, queenstown accommodation"
    />

    <h1>Self contained serviced apartment with remarkables mountains views from your Queenstown accommodation apartment</h1>
    <div className="header-inside">
      <img
        src="https://d2057z2iq79qyw.cloudfront.net/amity/bold.jpg"
        alt="About Queenstown Hill Apartment queenstown accommodation"
      />
      <div className="caption">
        <div className="caption-inner">
          <h2>Self catering Queenstown Hill Apartment</h2>
          <p>Make your stay more pleasant with Amity! </p>
        </div>
      </div>
    </div>
    <section className="grey">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12">
            <h3>About Queenstown Hill Apartment</h3>

            <p className="subtitle"></p>
            <p>
              Different location, same service. Enjoy breathtaking views of the
              surrounding mountains and the Wakatipu lake, from dusk till dawn.
            </p>
            <p>
              This elevated, self-contained holiday home treats your eyes to
              spectacular views of the surrounding lakes and mountains, without
              you ever needing to step outside your apartment. Offering beauty
              with a side of convenience, the apartment is located just the
              right distance away from the city centre, where you can enjoy some
              peaceful solitude at one of the most serene holiday homes
              Queenstown has to offer. Whether you’re a couple recapturing
              romance, or a group looking for their next ski adventure, this
              apartment has everything to make your holiday in Queenstown
              memorable.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="white">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12">
            <h3>Room Facilities</h3>
            <p>
              This vacation home comes with a fully equipped kitchen, as well as
              a comfortable and spacious lounge. Enjoy all Sky channels on a
              flat screen TV, an apartment accompanied with free unlimited wifi,
              and a balcony surrounded by panoramic views to soak in the morning
              sun and breathe in the evening air.
            </p>
            <p>
              This apartment comes with 1 Queen bed and 2 Single beds,
              accommodating a total of 4 guests.
            </p>
            <hr />
            <ul>
              <li>Off-street parking</li>
              <li>Air conditioned</li>
              <li>Bathroom amenities (free toiletries)</li>
              <li>Dryer</li>
              <li>Washing machine</li>
              <li>Flat Screen TV</li>
              <li>Free Wifi</li>
              <li>Full kitchen</li>
              <li>Hairdryer</li>
              <li>In-room heater</li>
              <li>Iron &amp; ironing board</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section className="grey">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12">
            <h3>Location</h3>

            <p>
              Enjoy convenience like no other. The apartment is located a mere 5
              minute drive, or a 30 minute walk, from the city centre, and only
              a 10 minute drive to the airport.
            </p>
            <p>
              Only a short drive away from the apartment are Queenstown Gardens,
              Queenstown Hill, Skyline Gondola, and Lake Wakatipu, just to name
              a few.
            </p>
            <p>12/69 Edinburgh Drive, 9300 Queenstown, New Zealand</p>
          </div>
        </div>
      </div>
    </section>
    <section className="white">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12">
            <h3>Gallery</h3>
            <p>
              Have a scroll through some images to catch a glimpse before you
              stay.
            </p>
          </div>
        </div>
        <div className="activities">
          <div className="row">
            {EaglesNestJson.map((item, index) => (
              <div key={index} className="col-12 col-lg-4 col-sm-6">
                <div className="activityBlock">
                  <Zoom zoomMargin={40}>
                    <img
                      alt={item.title}
                      src={item.previewImage}
                      className="img-fluid"
                    />
                  </Zoom>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default EaglesNestApartment;
